'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import ThemeToggle from '@/components/ThemeToggle';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();

  const navLinks = [
    { id: 'nav_home', label: 'Home', href: '/homepage' },
    { id: 'nav_about', label: 'About', href: '/about' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header data-component-id="src/components/Header.tsx:37:4" data-component-path="src/components/Header.tsx" data-component-line="37" data-component-end-line="130" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'py-4' : 'py-6'
      }`}
    >
      <nav data-component-id="src/components/Header.tsx:42:6" data-component-path="src/components/Header.tsx" data-component-line="42" data-component-end-line="129" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22container-custom%22%7D" className="container-custom">
        <div data-component-id="src/components/Header.tsx:43:8" data-component-path="src/components/Header.tsx" data-component-line="43" data-component-end-line="102" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          className={`glass-card rounded-full px-6 py-3 flex items-center justify-between transition-all duration-300 ${
            isScrolled ? 'shadow-xl glow-effect' : ''
          }`}
        >
          {/* Logo */}
          <Link data-component-id="src/components/Header.tsx:49:10" data-component-path="src/components/Header.tsx" data-component-line="49" data-component-end-line="64" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fhomepage%22%2C%22className%22%3A%22flex%20items-center%20hover%3Ascale-110%20transition-transform%20duration-300%22%7D"
            href="/homepage"
            className="flex items-center hover:scale-110 transition-transform duration-300"
          >
            <span data-component-id="src/components/Header.tsx:53:12" data-component-path="src/components/Header.tsx" data-component-line="53" data-component-end-line="63" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-3xl%20font-bold%20leading-none%22%2C%22textContent%22%3A%22%3CSS%3E%22%7D" 
              className="text-3xl font-bold leading-none" 
              style={{ 
                background: 'linear-gradient(135deg, #22D3EE 0%, #A78BFA 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              &lt;SS&gt;
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div data-component-id="src/components/Header.tsx:67:10" data-component-path="src/components/Header.tsx" data-component-line="67" data-component-end-line="83" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20gap-8%22%7D" className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link data-component-id="src/components/Header.tsx:69:14" data-component-path="src/components/Header.tsx" data-component-line="69" data-component-end-line="81" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                key={link.id}
                href={link.href}
                className={`text-sm font-medium transition-all duration-300 relative hover:scale-105 ${
                  pathname === link.href
                    ? 'text-foreground' :'text-muted-foreground hover:text-foreground'
                }`}
              >
                {link.label}
                {pathname === link.href && (
                  <span data-component-id="src/components/Header.tsx:79:18" data-component-path="src/components/Header.tsx" data-component-line="79" data-component-end-line="79" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20-bottom-1%20left-0%20right-0%20h-px%20bg-primary%20animate-scale-in%22%7D" className="absolute -bottom-1 left-0 right-0 h-px bg-primary animate-scale-in" />
                )}
              </Link>
            ))}
          </div>

          {/* Theme Toggle */}
          <div data-component-id="src/components/Header.tsx:86:10" data-component-path="src/components/Header.tsx" data-component-line="86" data-component-end-line="88" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%22%7D" className="hidden md:flex items-center">
            <ThemeToggle data-component-id="src/components/Header.tsx:87:12" data-component-path="src/components/Header.tsx" data-component-line="87" data-component-end-line="87" data-component-file="Header.tsx" data-component-name="ThemeToggle" data-component-content="%7B%22elementName%22%3A%22ThemeToggle%22%7D" />
          </div>

          {/* Mobile Menu Button */}
          <button data-component-id="src/components/Header.tsx:91:10" data-component-path="src/components/Header.tsx" data-component-line="91" data-component-end-line="101" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22md%3Ahidden%20text-foreground%20hover%3Atext-primary%20transition-all%20duration-300%20hover%3Ascale-110%20hover%3Arotate-90%22%7D"
            onClick={toggleMenu}
            className="md:hidden text-foreground hover:text-primary transition-all duration-300 hover:scale-110 hover:rotate-90"
            aria-label="Toggle menu"
          >
            <Icon data-component-id="src/components/Header.tsx:96:12" data-component-path="src/components/Header.tsx" data-component-line="96" data-component-end-line="100" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
              name={isMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={24}
              variant="outline"
            />
          </button>
        </div>

        {/* Mobile Menu */}
        <div data-component-id="src/components/Header.tsx:105:8" data-component-path="src/components/Header.tsx" data-component-line="105" data-component-end-line="128" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`md:hidden mt-4 glass-card rounded-2xl p-6 transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-96 opacity-100 animate-fade-in-up' : 'max-h-0 opacity-0 p-0 mt-0'
        }`}>
          {isMenuOpen && (
            <div data-component-id="src/components/Header.tsx:109:12" data-component-path="src/components/Header.tsx" data-component-line="109" data-component-end-line="126" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-4%22%7D" className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link data-component-id="src/components/Header.tsx:111:16" data-component-path="src/components/Header.tsx" data-component-line="111" data-component-end-line="121" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                  key={link.id}
                  href={link.href}
                  onClick={closeMenu}
                  className={`text-base font-medium transition-all duration-300 hover:translate-x-2 ${
                    pathname === link.href
                      ? 'text-foreground' :'text-muted-foreground hover:text-foreground'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div data-component-id="src/components/Header.tsx:123:14" data-component-path="src/components/Header.tsx" data-component-line="123" data-component-end-line="125" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22border-t%20border-border%20my-4%20pt-4%22%7D" className="border-t border-border my-4 pt-4">
                <ThemeToggle data-component-id="src/components/Header.tsx:124:16" data-component-path="src/components/Header.tsx" data-component-line="124" data-component-end-line="124" data-component-file="Header.tsx" data-component-name="ThemeToggle" data-component-content="%7B%22elementName%22%3A%22ThemeToggle%22%7D" />
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;